export const API_IS_BEING_CANCELLED = "Api is being cancelled";
export const BOOLEAN_FILTER = "booleanFilter";
export const CARRIER = "carrier";
export const COMPANY_FILTER = "companyFilter";
export const DESKTOP_DRAWER_OPEN = "DesktopDrawerOpen";
export const DEV = "dev";
export const DEVICE_EXPORT = "DeviceExport";
export const FALSE = "false";
export const INVALID = "Invalid";
export const INVALID_DATE = "invalidDate";
export const IS_DEVICE_STATISTICS_OPEN = "isDeviceStatisticsOpen";
export const I18_NEXT_LANG = "i18nextLng";
export const I18_NEXT_LANG_CHANGED = "i18nextLngChanged";
export const LEGACY = "Legacy";
export const NOT_ASSIGNED = "not assigned";
export const READ_NEWS = "readNews";
export const ROOT_COMPANY = "rootCompany";
export const SPEC_ID_NOT_ASSIGNED_VALUE = "null,0,1";
export const TRUE = "true";
export const TUTORIAL_INITIAL_RENDER = "tutorialInitialRender";
export const UNKNOWN = "Unknown";
export const X_INTERNAL_ACCESS = "x-internal-access";
